import { SafePromise } from '@benzinga/safe-await';

import {
  CampaignResponse,
  RedirectResponse,
  TranslationResponse,
  MortgageData,
  MortgageDataResponse,
  DentalInsuranceData,
  DentalInsuranceResponse,
  AskTheExpert,
  AskTheExpertResponse,
  SubscribeToNewsletterRequest,
  SubscribeToNewsletterResponse,
} from '../entities';
import { RestfulClient, Session } from '@benzinga/session';
import { ContentEnvironment } from '../environment';

export class ContentRestfulTools extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ContentEnvironment).toolsUrl, session);
  }

  public getRedirectByUrl = async (urlPath: string): SafePromise<RedirectResponse> => {
    const url = this.URL(`redirects`, {
      url: urlPath,
    });

    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  public getNodeTranslation = (node_id: string): SafePromise<TranslationResponse> => {
    const url = this.URL(`translations`, {
      node: node_id,
    });

    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  saveMortageLead = (data: MortgageData): SafePromise<MortgageDataResponse> => {
    const url = this.URL(`mortgage-lead`);
    return this.post(url, data, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  saveDentalInsuranceLead = (data: DentalInsuranceData): SafePromise<DentalInsuranceResponse> => {
    const url = this.URL(`dental-insurance-lead`);
    return this.post(url, data, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  saveAskTheExpertComment = (data: AskTheExpert): SafePromise<AskTheExpertResponse> => {
    const url = this.URL(`post/question`);
    return this.post(url, data, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  subscribeToNewsletter = (data: SubscribeToNewsletterRequest): SafePromise<SubscribeToNewsletterResponse> => {
    const url = this.URL(`subscribe-to-newsletter`);
    return this.post(url, data, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getCampaigns = (): SafePromise<CampaignResponse> => {
    const url = this.URL(`mortgage-lead-campaign`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
